import { gate } from 'hub-http/gates';
import { useEffect, useState } from 'react';
import { getFeature } from 'purchase-motions-api/query/featureStore';
import { getOwnsPaidPortal } from 'onboarding-scopes/js/monetization-utils/ownsTier';
import { useUserInfo } from '../../../hooks/useUserInfo';
import { ActivationSuccessModal } from './ActivationSuccessModal';
import { TrialActivationModal } from './ModalRedesign/TrialActivationModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActivationSuccessModalContainer = ({
  apiName,
  hideModal,
  upgradeConfig,
  showTrialLoadingState,
  onContinueClick
}) => {
  var _featureData$feature2;
  const {
    user
  } = useUserInfo();
  const isPaidPortal = user && getOwnsPaidPortal(user.user.scopes);
  const hasTrialActivationPromptGate = user === null || user === void 0 ? void 0 : user.gates.includes(gate('HiC::TrialActivationPrompt::Redesign'));
  const [featureData, setFeatureData] = useState({
    feature: undefined,
    fetched: false
  });
  useEffect(() => {
    if (upgradeConfig !== null && upgradeConfig !== void 0 && upgradeConfig.featureStoreFeature) {
      getFeature({
        shortName: upgradeConfig.featureStoreFeature
      }).then(feature => {
        setFeatureData({
          feature,
          fetched: true
        });
      }).catch(() => {
        setFeatureData({
          feature: undefined,
          fetched: true
        });
      });
    } else {
      setFeatureData({
        feature: undefined,
        fetched: true
      });
    }
  }, [upgradeConfig === null || upgradeConfig === void 0 ? void 0 : upgradeConfig.featureStoreFeature]);
  if (!featureData.fetched) {
    return null;
  }
  if (hasTrialActivationPromptGate) {
    var _featureData$feature;
    return /*#__PURE__*/_jsx(TrialActivationModal, {
      hidePrompt: hideModal,
      apiName: apiName,
      featureDisplayName: (_featureData$feature = featureData.feature) === null || _featureData$feature === void 0 ? void 0 : _featureData$feature.displayName,
      onContinueClick: onContinueClick,
      isPaidPortal: isPaidPortal || false
    });
  }
  return /*#__PURE__*/_jsx(ActivationSuccessModal, {
    apiName: apiName,
    onStartSuccess: onContinueClick,
    showTrialLoadingState: showTrialLoadingState,
    featureDisplayName: (_featureData$feature2 = featureData.feature) === null || _featureData$feature2 === void 0 ? void 0 : _featureData$feature2.displayName,
    onClose: hideModal
  });
};